export const HEADER_ACCEPT = 'Accept';
export const HEADER_AUTHORIZATION = 'Authorization';
export const HEADER_CONTENT_DISPOSITION = 'Content-Disposition';
export const HEADER_CONTENT_TYPE = 'Content-Type';
